export default __webpack_public_path__ + "static/media/Travelling.047aab0d.webp";